import UserNew from './UserNew';
import UserList from './UserList';

export default {
  UserNew,
  UserList,
};
